import cloneDeep from "lodash/cloneDeep";

import { SEARCH_APPEND_TERM_TO_HISTORY } from "../Actions/ActionSearch";

const inititalState = {
  accounts: {}
};

const HISTORY_ITEMS_LENGTH = 5;

export const getAccountSearchHistory = (state, id) => {
  return state.accounts[id] || { items: [] };
};

export const searchHistory = (state = inititalState, action) => {
  let newState = null,
      history = null;
  switch (action.type) {
    case SEARCH_APPEND_TERM_TO_HISTORY:
      newState = cloneDeep(state);
      history = getAccountSearchHistory(newState, action.accountId);

      if (history.items.find(item => item.id === action.item.id)) {
        history.items = history.items.filter(item => item.id !== action.item.id);
        history.items.unshift(action.item);
      } else {
        history.items.unshift(action.item);
        history.items = history.items.slice(0, HISTORY_ITEMS_LENGTH);
      }

      newState.accounts[action.accountId] = history;
      return newState;
    default:
      return state;

  }
};